module.exports = __webpack_public_path__ + "img/success-image.d149f254.png";